module.exports = __webpack_public_path__ + "static/media/doc.bee73e4d.svg";